export const TIME_FILTER_FIELD_NAME = 'time';
